import GeneralDetailCardComponent from "./GeneralDetailCardComponent";

export default GeneralDetailCardComponent